import React from "react";

const muted = { color: "var(--fb-text-muted)" };
const linkCls = "underline";

export default function AddressCheckPolicy() {
  return (
    <main className="min-h-screen px-4 py-10" style={{ background: "var(--fb-bg)" }} data-testid="address-check-policy">
      <div className="fb-card max-w-2xl mx-auto p-6 sm:p-8 space-y-5">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-semibold mb-2" style={{ color: "#8B918B" }}>Address checks</div>
          <h1 className="text-3xl font-bold" style={{ fontFamily: "Outfit" }}>Address check privacy and terms</h1>
        </div>
        <p className="text-sm" style={muted}>
          This page supplements the food bank's existing privacy and data policies. It does not replace them.
        </p>
        <section className="space-y-2">
          <h2 className="text-lg font-semibold" style={{ fontFamily: "Outfit" }}>What is sent</h2>
          <p className="text-sm">
            When you or a staff member choose to check an address with Google, only the address is sent: street, unit, city, state and ZIP.
            Names, email addresses and dates of birth are not sent. Normal automatic address checks send the address to USPS.
          </p>
        </section>
        <section className="space-y-2">
          <h2 className="text-lg font-semibold" style={{ fontFamily: "Outfit" }}>What a check means</h2>
          <p className="text-sm">
            A check is a hint, not a guarantee. It does not guarantee postal delivery, and it does not show whether anyone lives at the address or is eligible for services.
          </p>
        </section>
        <section className="space-y-2">
          <h2 className="text-lg font-semibold" style={{ fontFamily: "Outfit" }}>What is kept</h2>
          <p className="text-sm">
            The original address, or an address you or a staff member explicitly choose to use, is saved through the normal form save.
            In mailing reports, “Use suggested address” explicitly saves the confirmed correction to the household record.
            A Google verification tag records the checking and confirmation dates for that specific address; it is separate from residency verification.
            Check results live only on the page for about 15 minutes and are not cached by the server for Google.
            Checks never change residency verification status. Saving without a Google verification remains available.
          </p>
          <p className="text-sm">
            The server retains request counts and temporary, keyed request identifiers for abuse and cost controls, not Google's returned addresses or verdicts.
            Mailing CSVs contain the food bank's currently saved address, including any explicitly accepted correction, and may include our review status and check time, not an unsaved Google suggestion.
          </p>
        </section>
        <section className="space-y-2">
          <h2 className="text-lg font-semibold" style={{ fontFamily: "Outfit" }}>Google terms</h2>
          <ul className="text-sm list-disc pl-5 space-y-1">
            <li><a className={linkCls} href="https://cloud.google.com/maps-platform/terms" target="_blank" rel="noopener noreferrer">Google Maps Platform Terms of Service</a></li>
            <li><a className={linkCls} href="https://cloud.google.com/maps-platform/terms/maps-service-terms" target="_blank" rel="noopener noreferrer">Google Address Validation service-specific terms</a></li>
            <li><a className={linkCls} href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a></li>
          </ul>
        </section>
      </div>
    </main>
  );
}
